/**
 * Types inferred from current usage in codebase
 *
 * use the type guard below to set types on the window object before using.
 * ```
 * if (kochavaLoaded(window.kochava)) {
 *   // Types available here
 * }
 * ```
 *
 * @see kochavaLoaded
 */
export interface KochavaSDK {
  activity: (event: string, properties: object) => void
}

export const kochavaLoaded = (
  maybeKochava: KochavaSDK | unknown
): maybeKochava is KochavaSDK => {
  return (
    typeof maybeKochava === 'object' &&
    maybeKochava !== null &&
    'activity' in maybeKochava
  )
}
